import {
  Box,
  CircularProgress,
  Container,
  Fade,
  Grid,
  Tab,
  Tabs,
  Typography,
} from '@material-ui/core'
import { format } from 'date-fns'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { loadAvailableStoredCurrency } from '../api/api'
import { CreditsTable, WalletSummary } from '../components/wallet'
import { loadAvailableProgramStart } from '../redux/modules/checkout'
import { loadAvailableCreditsStart } from '../redux/modules/creditHistory'
import { loadPaymentOptionsStart } from '../redux/modules/profile'

function a11yProps(index) {
  return {
    'aria-controls': `simple-tabpanel-${index}`,
    id: `simple-tab-${index}`,
  }
}

function TabPanel(props) {
  const { children, index, value, ...other } = props

  return (
    <Typography
      aria-labelledby={`simple-tab-${index}`}
      component="div"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      role="tabpanel"
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </Typography>
  )
}

const PageWallet = () => {
  const [value, setValue] = useState(0)
  const [isLoading, setIsLoading] = useState(undefined)
  const [storedCurrency, setStoredCurrency] = useState(null)
  const dispatchRedux = useDispatch()
  const availableCredits = useSelector(state => state?.creditHistory?.availableCredits)
  const availableProgram = useSelector(state => state?.checkout?.programInfo)

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  useEffect(() => {
    async function loadData() {
      try {
        setIsLoading(true)
        dispatchRedux(loadPaymentOptionsStart())
        dispatchRedux(loadAvailableCreditsStart())
        dispatchRedux(loadAvailableProgramStart(format(new Date(), 'YYYY-MM-DD')))
        const giftAmount = await loadAvailableStoredCurrency()
        setStoredCurrency(giftAmount)
      } catch (e) {
        console.error(e.message)
      } finally {
        setIsLoading(false)
      }
    }
    loadData()
  }, [dispatchRedux])

  return (
    <Container style={{ minHeight: 'calc(100vh - 217px)' }}>
      <Box mb={4}>
        <Tabs indicatorColor="primary" onChange={handleChange} textColor="primary" value={value}>
          <Tab disabled={isLoading} label="Wallet" {...a11yProps(0)} />
          <Tab disabled={isLoading} label="Credits" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <TabPanel index={0} value={value}>
        <Grid container>
          <Grid item>
            <Box marginBottom={3}>
              <Typography component="h1" variant="h4">
                Wallet
                <Fade
                  in={isLoading}
                  style={{
                    marginLeft: '8px',
                    transitionDelay: '800ms',
                  }}
                >
                  <CircularProgress size={20} />
                </Fade>
              </Typography>
            </Box>
          </Grid>
        </Grid>
        <Grid container justify="center">
          <Grid item md={10} xs={12}>
            <Box marginBottom={5}>
              <WalletSummary
                credits={availableCredits}
                gifts={storedCurrency}
                program={availableProgram}
              />
            </Box>
          </Grid>
        </Grid>
      </TabPanel>
      <TabPanel index={1} value={value}>
        <Grid container>
          <Grid item>
            <Box marginBottom={3}>
              <Typography component="h1" variant="h4">
                Credits
              </Typography>
            </Box>
          </Grid>
        </Grid>
        <Grid container justify="center">
          <Grid item xs={12}>
            <Box marginBottom={4}>
              <CreditsTable />
            </Box>
          </Grid>
        </Grid>
      </TabPanel>
    </Container>
  )
}

export default PageWallet
